<template>
  <div id="app" v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(255, 255, 255, 0)">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import newVue from 'common/js/newVue'
export default {
  data() {
    return {
      fullscreenLoading: false,
      isRouterAlive: true
    }
  },
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  },
  created() {
    newVue.$on('toggleLoading', (show) => {
      this.fullscreenLoading = show
    })
  }
}
</script>

<style lang="scss">
  @import "~common/scss/reset";
  .myClass .el-submenu__icon-arrow .el-icon-arrow-down{
    color: #333 !important;
    display: none!important;
  }
  .myClass .el-icon-arrow-down::before{
    color: #333!important;
    display: none!important;
  }
  #app{
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height:100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue